/* eslint-disable react/prop-types */
import * as React from 'react';

export const MultipleUsers = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3471 16.5689C22.6171 14.2829 20.6821 12.9749 18.0271 12.9749H18.0081C16.9261 12.9649 15.9591 13.1829 15.1431 13.5999C17.4201 14.3309 19.1081 15.9529 19.8851 18.2479C21.1181 18.0769 22.1901 17.6979 23.1381 17.1189L23.4511 16.9199L23.3471 16.5689Z"
      fill={props.color || '#64748B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2903 11.2484C16.8023 11.5334 17.3813 11.6944 18.0073 11.6944C19.9703 11.6944 21.5633 10.1004 21.5633 8.13733C21.5633 6.18433 19.9703 4.59033 18.0073 4.59033C17.6183 4.59033 17.2483 4.65733 16.8973 4.77033C17.4093 5.59633 17.7033 6.57233 17.7033 7.60633C17.7033 9.01033 17.1813 10.2814 16.2903 11.2484Z"
      fill={props.color || '#64748B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30983 13.5816C8.51283 13.1836 7.57383 12.9746 6.51183 12.9746H6.47383C3.81883 12.9746 1.88383 14.2836 1.16283 16.5686L1.04883 16.9196L1.36183 17.1186C2.26283 17.6696 3.32583 18.0386 4.51083 18.2286C5.29783 15.9246 7.01483 14.2926 9.30983 13.5816Z"
      fill={props.color || '#64748B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.49377 11.6939C7.11977 11.6939 7.69777 11.5329 8.21077 11.2479C7.31877 10.2809 6.79677 9.00984 6.79677 7.60584C6.79677 6.57284 7.09077 5.59584 7.60377 4.77084C7.25277 4.65684 6.88277 4.58984 6.49377 4.58984C4.53077 4.58984 2.93677 6.18384 2.93677 8.13684C2.93677 10.1009 4.53077 11.6939 6.49377 11.6939Z"
      fill={props.color || '#64748B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.216 14.1035C12.2 14.1035 12.185 14.1035 12.17 14.1035C8.756 14.1035 6.267 15.7815 5.341 18.7105L5.229 19.0645L5.546 19.2585C7.354 20.3605 9.514 20.8965 12.149 20.8965H12.234C14.871 20.8965 17.032 20.3605 18.84 19.2585L19.158 19.0645L19.046 18.7105C18.119 15.7815 15.631 14.1035 12.216 14.1035Z"
      fill={props.color || '#64748B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2507 12.1185C14.7367 12.1185 16.7587 10.0965 16.7587 7.61052C16.7587 5.12552 14.7367 3.10352 12.2507 3.10352C9.76468 3.10352 7.74268 5.12552 7.74268 7.61052C7.74268 10.0965 9.76468 12.1185 12.2507 12.1185Z"
      fill={props.color || '#64748B'}
    />
  </svg>
);
